import React from 'react';
import PropTypes from 'prop-types';
import { useMutation } from '@common/hooks';
import FormHealthDocumentTemplate from './form-health-document-template';
import { createMessage } from 'works/legacy/lib/message-helper';
import { CreateHealthDocumentItemTemplate } from 'works/graphql/works-list-item-template';
import { addErrorsToForm } from 'works/legacy/lib/form-helpers';

export default function CreateHealthDocumentTemplate({
  dismiss,
  worksListTemplateId,
  form,
}) {
  const handleMutationCompletion = (response) => {
    if (response.createHealthDocumentItemTemplate.errors) {
      addErrorsToForm(form, response.createHealthDocumentItemTemplate.errors);

      createMessage(
        'error',
        'Failed to update Compliance Item. Please try again.'
      );
    } else {
      createMessage('success', 'Compliance Item created!');
      dismiss();
    }
  };

  const [createHealthDocument] = useMutation(CreateHealthDocumentItemTemplate, {
    onCompleted: handleMutationCompletion,
    onError: () =>
      createMessage(
        'error',
        'Failed to create Compliance Item. Please try again.'
      ),
  });

  const handleSubmit = (values) => {
    createHealthDocument({
      variables: {
        worksListTemplateId: worksListTemplateId,
        input: values,
      },
    });
  };

  return (
    <FormHealthDocumentTemplate
      showSeason={true}
      dismiss={dismiss}
      handleSubmit={handleSubmit}
      initialValues={{
        active: true,
        expirationType: 'COMPLETION_DATE',
        daysToExpiry: 365,
      }}
      showExpiration
      form={form}
    />
  );
}

CreateHealthDocumentTemplate.propTypes = {
  dismiss: PropTypes.func.isRequired,
  worksListTemplateId: PropTypes.string.isRequired,
  form: PropTypes.object.isRequired,
};
